import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";


export class CustomValidators {
  static patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        // si el control está vacío no devuelve ningún error
        return null as any;
      }

      // probar el valor del control contra la expresión regular suministrada
      const valid = regex.test(control.value);
      //si es verdadero, no devuelve ningún error (sin error), de lo contrario, devuelve el error pasado en el segundo parámetro
      return valid ? null as any : error;
    };
  }

  static passwordMatchValidator(control: AbstractControl) {
    const password: string = control.get('passwordHash')?.value; //obtener contraseña de nuestro control de formulario de contraseña
    const confirmPassword: string = control.get('confirmPasswordHash')?.value; // obtenga la contraseña de nuestro control de formulario confirmPassword
    // Comparar si las contraseñas coinciden
    if (password !== confirmPassword) {
      // si no coinciden, establezca un error en nuestro control de formulario confirmPassword
      control.get('confirmPasswordHash')?.setErrors({ NoPassswordMatch: true });
    }
  }

  static numberOnlyValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === undefined || value === '') { return null; }
      return typeof value === 'number' && !isNaN(value) ? null : { notNumber: true };
    };
  }
}
